import script from "./BadgesResumen.vue?vue&type=script&setup=true&lang=js"
export * from "./BadgesResumen.vue?vue&type=script&setup=true&lang=js"

import "./BadgesResumen.vue?vue&type=style&index=0&id=039dfaae&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-039dfaae"]])

export default __exports__